/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedSignedTranscriptStatusList } from '../models/PaginatedSignedTranscriptStatusList';
import type { PatchedSignedTranscriptStatus } from '../models/PatchedSignedTranscriptStatus';
import type { SignedTranscriptStatus } from '../models/SignedTranscriptStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsSignedTranscriptStatusService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedSignedTranscriptStatusList
     * @throws ApiError
     */
    public clientsSignedTranscriptStatusList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedSignedTranscriptStatusList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-signed-transcript-status/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns SignedTranscriptStatus
     * @throws ApiError
     */
    public clientsSignedTranscriptStatusCreate({
        requestBody,
    }: {
        requestBody: SignedTranscriptStatus,
    }): CancelablePromise<SignedTranscriptStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-signed-transcript-status/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns SignedTranscriptStatus
     * @throws ApiError
     */
    public clientsSignedTranscriptStatusRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this signed transcript status.
         */
        id: number,
    }): CancelablePromise<SignedTranscriptStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-signed-transcript-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns SignedTranscriptStatus
     * @throws ApiError
     */
    public clientsSignedTranscriptStatusUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this signed transcript status.
         */
        id: number,
        requestBody: SignedTranscriptStatus,
    }): CancelablePromise<SignedTranscriptStatus> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-signed-transcript-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns SignedTranscriptStatus
     * @throws ApiError
     */
    public clientsSignedTranscriptStatusPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this signed transcript status.
         */
        id: number,
        requestBody?: PatchedSignedTranscriptStatus,
    }): CancelablePromise<SignedTranscriptStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-signed-transcript-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsSignedTranscriptStatusDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this signed transcript status.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-signed-transcript-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
